module.exports = __webpack_public_path__ + "img/note.23b518cc.svg";